<mat-toolbar color="primary" style="margin: 45;">


  <button mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">Menu</button>
  <mat-menu #menu="matMenu" class="rr-menu">
    <button class="menu-Btn rr-menu" mat-menu-item routerLink="/home">Home</button>

    <button *ngIf="auth.isAdmin$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/add-class"><b>Create Classes</b></button>
    <button *ngIf="auth.isAdmin$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/verify"><b>Verify Classes</b></button>
    <button *ngIf="auth.isAdmin$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/admin"><b>Class Lists</b></button>
    <button *ngIf="auth.isAdmin$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/email-template"><b>Email Templates</b></button>
    
    <button *ngIf="auth.isAssistant$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/signup">Signup
    </button>

    <button *ngIf="auth.loggedIn$ | async" class="menu-Btn rr-menu" mat-menu-item routerLink="/member"><b>Member</b>
    </button>

    <button class="menu-Btn" mat-menu-item [matMenuTriggerFor]="classesMenu">Classes</button>

    <mat-menu #classesMenu="matMenu">
      <button class="menu-Btn rr-menu" mat-menu-item routerLink="/zoom">Zoom Class</button>
      <button class="menu-Btn rr-menu" mat-menu-item routerLink="/bootcamp">Bootcamp Class</button>
      <button class="menu-Btn rr-menu" mat-menu-item routerLink="/adv-class">Advanced Zoom Class</button>
    </mat-menu>

    <button class="menu-Btn" mat-menu-item routerLink="/videotraining">Video Audio</button>
    <button class="menu-Btn" mat-menu-item routerLink="/snippets">Training Snippets</button>
    <button class="menu-Btn" mat-menu-item routerLink="/tools">Free Tools/Guides</button>
    <button class="menu-Btn" mat-menu-item routerLink="/questions">Common Questions</button>
    <button class="menu-Btn" mat-menu-item [matMenuTriggerFor]="delegateMenu">Delegates</button>

    <mat-menu #delegateMenu="matMenu">
      <button class="menu-Btn" mat-menu-item routerLink="/michigangop">MIGOP Tools</button>
      <button class="menu-Btn" mat-menu-item routerLink="/stateparty">State Party</button>
      <button class="menu-Btn" mat-menu-item routerLink="/delegate">Delegates</button>
      <button class="menu-Btn" mat-menu-item routerLink="/stateconvention">State Convention</button>
      <button class="menu-Btn" mat-menu-item routerLink="/countyconvention">County Convention</button>
      <button class="menu-Btn" mat-menu-item routerLink="/timeline">Timeline</button>
      <button class="menu-Btn" mat-menu-item routerLink="/documents">Documents</button>
      <button class="menu-Btn" mat-menu-item routerLink="/roberts">RONR for Delegates</button>
    </mat-menu>

    <button class="menu-Btn" mat-menu-item routerLink="/contactus">Contact Us</button>

    <button class="menu-Btn rr-menu" mat-menu-item [routerLink]="(auth.loggedIn$ | async) ? '/logout' : '/login'">
      {{ (auth.loggedIn$ | async) ? 'Logout' : 'Login' }}
    </button>
  </mat-menu>

  <span class="spacer"></span>

  <span id="home-link"><a routerLink="/home" aria-label="Return to RR Bootcamp homepage">RR Bootcamp</a></span>

</mat-toolbar>
<router-outlet></router-outlet>